import React, { createContext, useContext, useState, useCallback } from 'react';
import { Joyride, STATUS, EVENTS } from 'react-joyride';

const TourContext = createContext();

export function TourProvider({ children }) {
  const [tourState, setTourState] = useState({
    run: false,
    steps: [],
    tourKey: '',
  });

  const startTour = useCallback((tourName, steps) => {
    setTourState({
      run: true,
      steps: steps,
      tourKey: tourName,
    });
  }, []);

  const stopTour = useCallback(() => {
    setTourState(prev => ({ ...prev, run: false }));
  }, []);

  const handleJoyrideCallback = useCallback((data) => {
    const { status, type } = data;
    if ((status === STATUS.FINISHED || status === STATUS.SKIPPED) && type === EVENTS.TOUR_END) {
      // Mark tour as completed in localStorage
      if (tourState.tourKey) {
        localStorage.setItem(`${tourState.tourKey}TourShown`, 'true');
      }
      stopTour();
    }
  }, [stopTour, tourState.tourKey]);

  return (
    <TourContext.Provider value={{ startTour, stopTour }}>
      {children}
      <Joyride
        run={tourState.run}
        steps={tourState.steps}
        callback={handleJoyrideCallback}
        continuous
        showProgress
        showSkipButton
        scrollToFirstStep
        styles={{
          options: {
            primaryColor: '#3b82f6',
            textColor: '#1f2937',
            backgroundColor: '#ffffff',
            overlayColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
        locale={{
          back: 'Geri',
          close: 'Kapat',
          last: 'Bitir',
          next: 'İleri',
          skip: 'Atla',
        }}
      />
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}
